import { z } from 'zod';
export const RecurringInvoicePeriodicitySchema = z.enum([
    'MONTHLY',
    'BIMONTHLY',
    'QUARTERLY',
    'YEARLY',
]);
export const RecurringInvoicePeriodicityLabel = {
    MONTHLY: 'Mensual',
    BIMONTHLY: 'Bimestral',
    QUARTERLY: 'Trimestral',
    YEARLY: 'Anual',
};
export const RecurringInvoiceStatusSchema = z.enum(['ACTIVE', 'PAUSED', 'CANCELED']);
export const RecurringInvoiceStatusLabel = {
    ACTIVE: 'Activa',
    PAUSED: 'Pausada',
    CANCELED: 'Cancelada',
};
const decimalString = z
    .union([z.number(), z.string()])
    .transform((v) => (typeof v === 'number' ? v.toString() : v));
export const RecurringInvoiceLineInputSchema = z.object({
    position: z.number().int().min(0).default(0),
    description: z.string().min(1).max(500),
    quantity: decimalString.default('1'),
    unitPriceCents: z.number().int(),
    discountPct: decimalString.default('0'),
    vatRate: decimalString.default('0.21'),
    isSupplied: z.boolean().default(false),
});
export const RecurringInvoiceLineDtoSchema = RecurringInvoiceLineInputSchema.extend({
    id: z.string(),
});
export const RecurringInvoiceDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientDisplayName: z.string(),
    caseId: z.string().nullable(),
    caseCode: z.string().nullable(),
    seriesId: z.string().nullable(),
    seriesPrefix: z.string().nullable(),
    name: z.string(),
    notes: z.string().nullable(),
    periodicity: RecurringInvoicePeriodicitySchema,
    dayOfMonth: z.number().int(),
    irpfRate: z.string(),
    status: RecurringInvoiceStatusSchema,
    nextRunDate: z.string().datetime(),
    lastRunAt: z.string().datetime().nullable(),
    generatedCount: z.number().int(),
    createdAt: z.string().datetime(),
    createdByName: z.string().nullable(),
    lines: z.array(RecurringInvoiceLineDtoSchema),
});
export const CreateRecurringInvoiceSchema = z.object({
    clientId: z.string(),
    caseId: z.string().nullable().optional(),
    seriesId: z.string().nullable().optional(),
    name: z.string().min(2).max(200),
    notes: z.string().max(2000).nullable().optional(),
    periodicity: RecurringInvoicePeriodicitySchema.default('MONTHLY'),
    dayOfMonth: z.coerce.number().int().min(1).max(28).default(1),
    irpfRate: decimalString.optional(),
    /** Fecha de la primera factura a generar (yyyy-mm-dd o ISO). Si null, calculamos a partir de periodicity+dayOfMonth desde hoy. */
    startDate: z.string().nullable().optional(),
    lines: z.array(RecurringInvoiceLineInputSchema).min(1),
});
export const UpdateRecurringInvoiceSchema = CreateRecurringInvoiceSchema.partial().extend({
    status: RecurringInvoiceStatusSchema.optional(),
    nextRunDate: z.string().nullable().optional(),
});
export const RecurringInvoiceListResponseSchema = z.object({
    items: z.array(RecurringInvoiceDtoSchema),
});
//# sourceMappingURL=recurring.js.map